import React from 'react';
import { brand, launch } from '../mock/data';
import { useCountdown } from './Countdown';

const pad = (n) => String(n).padStart(2, '0');

const Segment = ({ d, h, m, s, done }) => (
  <div className="flex items-center shrink-0">
    <span className="font-display uppercase text-[12px] sm:text-[13px] tracking-[0.16em] px-5 sm:px-7 whitespace-nowrap">
      {done ? (
        'The Halloween drop is live'
      ) : (
        <>
          Halloween drop · delivery {launch.dateLabel} in{' '}
          <span className="tabular-nums">
            {pad(d)}d {pad(h)}h {pad(m)}m {pad(s)}s
          </span>
        </>
      )}
    </span>
    <span className="h-1 w-1 rounded-full bg-white/70" />
    <span className="font-display uppercase text-[12px] sm:text-[13px] tracking-[0.16em] px-5 sm:px-7 whitespace-nowrap">
      Spend $200, get a free tote ($25 value) · In-store Oct 30
    </span>
    <img src={brand.marks.lotusLight} alt="" className="h-3.5 w-auto opacity-90 mx-1" />
  </div>
);

const TickerBar = () => {
  const parts = useCountdown();
  return (
    <div
      data-testid="countdown-ticker"
      className="fixed top-0 left-0 right-0 z-[70] h-9 flex items-center overflow-hidden text-white border-b border-white/15"
      style={{ background: 'var(--accent)' }}
    >
      <div className="ticker-track" aria-label="Countdown to the Halloween drop">
        {[0, 1].map((dup) => (
          <Segment key={dup} {...parts} />
        ))}
      </div>
    </div>
  );
};

export default TickerBar;
